<template>
<div class="cents">
    <van-nav-bar
        :title="$t('fkwm')"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
        />
        <div class="feekcontent">
        <h4 style="text-align: left;">{{$t('fkwm')}}:</h4>
        <van-cell-group>
            <van-field v-model="title" :label="$t('bt')" :placeholder="$t('qsrbt')" />
        </van-cell-group>
        <van-cell-group>
            <van-field
            v-model="desc"
            rows="2"
            autosize
            :label="$t('ly')"
            type="textarea"
            maxlength="100"
            :placeholder="$t('qsrly')"
            show-word-limit
            />
        </van-cell-group>

        <div class="sumbifeek">
            <van-button size="small" @click="handfeedback" color="#1ABC9C">{{$t('tjfk')}}</van-button>
        </div>
    </div>
</div>
    
</template>
<script>
import { Toast } from 'vant';
export default {
    data(){
        return{
            title:'',
            desc:'',
            Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
            timer:null
        }
    },
    methods:{
        goto(){
            this.$router.go(-1)
        },
        handfeedback(){
            if(!this.title){
                Toast.fail(this.$t('qtxbt'));
                return false
            }
            if(!this.desc){
                Toast.fail(this.$t('qtxnr'));
                return false
            }
            let data ={
                method:'co.wx.feedback.add',
                user_id:this.Userof.user_id,
                title:this.title,
                desc:this.desc
            }
            this.$serve(data).then(res=>{
                if(res.data.code==0){
                    Toast.success(this.$t('ysdfkgx'))
                    this.$router.go(-1)
                    
                }else{
                    Toast.fail(this.$t('fksb'));
                }
            })
        }
    },
    // updated(){
    //     clearInterval(this.timer);
    // }
}
</script>
<style scoped>
.feekcontent{
    width: 90%;
    margin: 0 auto;
    
}
.sumbifeek{
    padding-top: 30px;
}
.sumbifeek >>>.van-button--small{
    border-radius: 5px;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
</style>